<template>
  <div class="feature">
    <div class="feature-inner" >
      <div class="feature-header">{{ title }}</div>
      <div class="feature-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mobile-demo-feature',
  data () {
    return {
      index: 0
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    screenshootSrc: {
      type: String,
      required: true
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/_variables.scss';

.feature {
  display: flex;
  flex-flow: column nowrap;
  height: 100vh;
  /*max-width: 265px;*/
  clear: both;
  align-items: center;
  margin: auto 0;
  padding-left: calc(50% + 3rem);
}

.feature-inner {
  max-width: 365px;
  margin: auto 0;
}

.feature-header {
  font-size: $size-4;
}

.feature-body {
  font-size: $size-7;
}

/*.feature.segment {
  max-width: 50%;
  text-align: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.feature[class*="right floated"].segment {
  right: 0;
}*/

@media screen and (min-width: $tablet) {
  .feature-header {
    font-size: $size-2;
  }

  .feature-body {
    font-size: $size-5;
  }
}

</style>



// WEBPACK FOOTER //
// MobileDemoFeature.vue?7743a9a6